import {
  CSS_PROPERTIES,
  CssCustomProperties,
  CssProperties,
} from '@wix/component-protocol/schema';
import { ValueOf } from '@wix/document-services-types';
import { getAllowedPropertiesForAction } from '../constants';
import { StylesDerivedNativeActionNames } from '@wix/editor-platform-host-integration-apis';
import { Styles } from '../types';

const isAllowedStyle = (
  value: NonNullable<ValueOf<CssCustomProperties>>,
  allowedStyles: readonly ValueOf<typeof CSS_PROPERTIES.CSS_PROPERTY_TYPE>[],
): boolean => {
  const cssPropertyType = value?.cssPropertyType;

  return !!cssPropertyType && allowedStyles.includes(cssPropertyType);
};

const filterCustomPropertyStylesByActionName = (
  actionName: StylesDerivedNativeActionNames,
  styleProperties: CssCustomProperties,
): CssCustomProperties => {
  const allowedStyles = getAllowedPropertiesForAction(actionName);

  if (!allowedStyles) {
    return {};
  }

  const filteredStyles: CssCustomProperties = {};

  Object.keys(styleProperties).forEach((key) => {
    const value = styleProperties[key];
    if (isAllowedStyle(value, allowedStyles)) {
      filteredStyles[key] = value;
    }
  });

  return filteredStyles;
};

const filterCssPropertyStylesByActionName = (
  actionName: StylesDerivedNativeActionNames,
  styleProperties: CssProperties,
): CssProperties => {
  const allowedStyles: readonly ValueOf<
    typeof CSS_PROPERTIES.CSS_PROPERTY_TYPE
  >[] = getAllowedPropertiesForAction(actionName);

  if (!allowedStyles) {
    return {};
  }

  const properties = Object.keys(styleProperties) as ValueOf<
    typeof CSS_PROPERTIES.CSS_PROPERTY_TYPE
  >[];

  const filteredStyles: CssProperties = {};

  properties.forEach((cssPropertyType) => {
    const value = styleProperties[cssPropertyType];
    if (allowedStyles.includes(cssPropertyType)) {
      filteredStyles[cssPropertyType] = value;
    }
  });

  return filteredStyles;
};

export const filterStylesByActionName = (
  actionName: StylesDerivedNativeActionNames,
  styles: Styles,
): Styles => {
  const { cssCustomProperties, cssProperties } = styles;

  return {
    cssCustomProperties: filterCustomPropertyStylesByActionName(
      actionName,
      cssCustomProperties,
    ),
    cssProperties: filterCssPropertyStylesByActionName(
      actionName,
      cssProperties,
    ),
  };
};
